const QUICK_SEARCH = 'Quick Search';
const SEARCH_SELECTED = 'Search Selected';

const quickSearchAnalyticsConstants = {
  QUICK_SEARCH,
  SEARCH_SELECTED,
};

export default quickSearchAnalyticsConstants;
